import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/company';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">{t('testimonialTitle')}</h2>
            <p className="text-sm md:text-base text-foreground-600">{t('testimonialDesc')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((item, i) => (
              <div key={i} className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">{item.content}</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                    <div className="text-xs text-foreground-500">{item.role} · {item.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}